import clsx from 'classnames';
import Image from 'next/image';
import { Container, ContainerFluid } from '../../components';
import amalthea from '../../public/mvp/AMALTHEA.png';
import foodyU from '../../public/mvp/foodyU.png';
import footer from '../../public/mvp/footer.png';
import wotcha from '../../public/mvp/wotcha.png';
import styles from './mvp-launched.module.css';
import commonStyles from './mvp.module.css';

const cards = [
  {
    id: 1,
    image: amalthea,
    title: 'AMALTHEA',
    description:
      'Amalthea carries out apartment renovations and refurbishments. The platform allows to manage the properties sales and rental process as well as take over the complete handling for the clients.',
    link: 'https://amaltheare.com/',
  },
  {
    id: 1,
    image: wotcha,
    title: 'WOTCHA',
    description:
      'Wotcha is the premier Caller ID and Spam Blocking app in the UK, offering a completely free service to help you immediately recognise and handle unidentified numbers, spam calls, and call centers',
    link: 'https://wotcha.uk/',
  },
  {
    id: 1,
    image: foodyU,
    title: 'FOODY U',
    description:
      'The ultimate nutrition App for Athletes. Personalised algorithm that helps to adapt your nutrition to training schedule & lifestyle',
    link: 'https://foodyu.app/',
  },
];

export default function MVPLaunched() {
  return (
    <section className={styles.launched}>
      <ContainerFluid>
        <Container>
          <div className={styles.content}>
            <h2 className={commonStyles.h2} id="works">
              launched. loved. in just 6 weeks.
            </h2>
            <p className={clsx(commonStyles.text, styles.text)}>
              Banking software development from scratch, existing systems’
              improvement, and on-demand intelligent solutions to optimize
              eBanking services and workflows
            </p>
          </div>
        </Container>
        <ul className={styles.list}>
          {cards.map((card) => (
            <li key={card.id} className={styles.card}>
              <Image
                src={card.image}
                alt={card.title}
                className={styles.image}
                height={790}
                width={545}
                objectFit="contain"
              />
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardDescription}>{card.description}</p>
              </div>
              <a href={card.link} className={styles.button}>
                Go to {card.title} website
              </a>
            </li>
          ))}
        </ul>
        <Image alt="footer" src={footer} width={1920} height={455} />
      </ContainerFluid>
    </section>
  );
}
